export const SHARED_CONFIG: {
	projectId: string,
  cloudRegion: 'us-central1' | 'us-east1' | 'us-east4' | 'europe-west1' | 'europe-west2' | 'asia-east2' | 'asia-northeast1';
} = {
	projectId: 'ace-analyzee',
	cloudRegion: 'us-central1',
};
